import './components/share'

import './scss/st16/styles.scss'
